import { combineReducers } from 'redux';
import { USER_LOGOUT } from './ducks/auth.duck';
import * as globalReducers from './ducks';
import * as pageReducers from './containers/reducers';

/**
 * Function _createReducer_ combines global reducers (reducers that are used in
 * multiple pages) and reducers that are handling actions happening inside one page container.
 * Since we combineReducers, pageReducers will get page specific key (e.g. SearchPage)
 * which is page specific.
 * Future: this structure could take in asyncReducers, which are changed when you navigate pages.
 */
const appReducer = combineReducers({ ...globalReducers, ...pageReducers });

const createReducer = () => {
  return (state, action) => {
    const appState = action.type === USER_LOGOUT ? undefined : state;

    // Clear sessionStorage when logging out, but NOT during guest signup completion
    if (action.type === USER_LOGOUT && typeof window !== 'undefined' && !!window.sessionStorage) {
      // Check if this is part of guest signup completion process
      const isGuestSignupProcess =
        sessionStorage.getItem('guest_signup_completed') ||
        sessionStorage.getItem('guest_signup_new_credentials');

      if (!isGuestSignupProcess) {
        // Only clear sessionStorage for normal logouts, not during guest signup
        window.sessionStorage.clear();
      }
    }

    return appReducer(appState, action);
  };
};

export default createReducer;
